// Breakout rooms need no server changes: each room is an ordinary meeting created by the host, marked by its subject and
// description, and the host's "open" and "close" commands travel as system lines in the MAIN meeting's chat that every room watches.

/** Rooms are named "Breakout room · <name>" and are left out of the calendar and the chat list. */
export const BREAKOUT_SUBJECT_PREFIX = "Breakout room · ";
export const isBreakoutSubject = (subject: string | null | undefined) => (subject ?? "").startsWith(BREAKOUT_SUBJECT_PREFIX);
/** Meeting chats are listed as "Meeting: <subject>". */
export const isBreakoutChatTitle = (title: string | null | undefined) => (title ?? "").startsWith(`Meeting: ${BREAKOUT_SUBJECT_PREFIX}`);

const PARENT = /^fg-breakout-of:([0-9a-fA-F-]{36})/;
export const breakoutDescription = (parentMeetingId: string) => `fg-breakout-of:${parentMeetingId}`;
export const breakoutParentOf = (description: string | null | undefined): string | null => PARENT.exec(description ?? "")?.[1] ?? null;

export interface BreakoutRoom {
    /** The room's meeting id. */
    id: string;
    name: string;
    /** Normalised ids of the people sent there. */
    members: string[];
}

export type BreakoutCommand =
    | { t: "open"; rooms: BreakoutRoom[] }
    | { t: "close" };

/** The system line that carries a command; it reads as a normal note in the chat. */
export function commandHtml(cmd: BreakoutCommand, text: string): string {
    const payload = btoa(unescape(encodeURIComponent(JSON.stringify(cmd))));
    const safe = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return `<p data-fg-system="1" data-fg-breakout="${payload}"><em>${safe}</em></p>`;
}

/** The command in a message body, or null. */
export function parseCommand(html: string): BreakoutCommand | null {
    const m = /data-fg-breakout="([A-Za-z0-9+/=]+)"/.exec(html);
    if (!m) return null;
    try {
        const cmd = JSON.parse(decodeURIComponent(escape(atob(m[1]!)))) as BreakoutCommand;
        if (cmd.t === "close") return cmd;
        if (cmd.t === "open" && Array.isArray(cmd.rooms)) return cmd;
    } catch {
        /* not ours or damaged */
    }
    return null;
}
